import { ArrowLeftOutlined } from "@ant-design/icons";
import { Breadcrumb, Button, Flex, Typography } from "antd";
import { useEffect } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import ComplianceReview from "../../components/Compliance/ComplianceReview.component";
import Encounter from "../../components/Compliance/Encounter.component";
import { useAppDispatch, useAppSelector } from "../../hooks/redux-hooks";
import { setNotesDetails } from "../../slices/notesSlice";
import styles from "./compliance.module.scss";

const ComplianceNoteReview = () => {
  const { userId, noteId } = useParams<{ userId: string; noteId: string }>();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { notesDetails } = useAppSelector((state) => state.notes);
  const { userInfo } = useAppSelector((state) => state.auth);

  const numericNoteId = Number(noteId);
  const numericUserId = Number(userId);

  useEffect(() => {
    return () => {
      dispatch(setNotesDetails(null));
    };
  }, [dispatch]);

  if (!userInfo?.show_compliance_dashboard || !userInfo?.is_group_admin) {
    return <Navigate to="/home" replace />;
  }
  if (!numericNoteId || !numericUserId) {
    return <Navigate to="/compliance/clinicians" replace />;
  }

  const noteTitle = notesDetails?.title || `Note #${numericNoteId}`;

  return (
    <div className={styles.compliance__container}>
      <Flex align="center" gap={8} wrap="wrap" style={{ marginBottom: 16 }}>
        <Button
          type="text"
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate(`/compliance/clinicians/${userId}`)}
          size="small"
          style={{ color: "#6b7280" }}
        />
        <Breadcrumb
          items={[
            {
              title: (
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/compliance");
                  }}
                >
                  Compliance
                </a>
              ),
            },
            {
              title: (
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/compliance/clinicians");
                  }}
                >
                  Clinicians
                </a>
              ),
            },
            {
              title: (
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(`/compliance/clinicians/${userId}`);
                  }}
                >
                  Clinician
                </a>
              ),
            },
            { title: noteTitle },
          ]}
        />
      </Flex>

      <div style={{ marginBottom: 24 }}>
        <Typography.Title level={4} style={{ margin: 0 }}>
          {noteTitle}
        </Typography.Title>
        {notesDetails?.client_name && (
          <Typography.Text style={{ color: "#6b7280" }}>{notesDetails.client_name}</Typography.Text>
        )}
      </div>

      {/* Admin review: always surface the flagged findings for this note,
          regardless of the group's compliance UI visibility. */}
      <ComplianceReview audioFileId={numericNoteId} forceShow />

      <Encounter
        noteId={numericNoteId}
        onFailRetry={() => navigate(`/compliance/clinicians/${userId}`)}
        failBackLabel="Back to clinician"
      />
    </div>
  );
};

export default ComplianceNoteReview;
